// extracted by mini-css-extract-plugin
var _1 = "UpgradeBadge-module__boltIcon--t1XeC";
export { _1 as "boltIcon" }
